import type { UseModelRestoreProps } from "./model-restore.type";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { client } from "@/config/client";
import { getModelApiKey, getModelQueryKey } from "@/modules/model";

export const useModelRestore = ({
  model,
  id,
  invalidateKeys,
}: UseModelRestoreProps) => {
  const apiModel = getModelApiKey(model);
  const queryKey = getModelQueryKey(model);

  const queryClient = useQueryClient();

  const mutationFn = () => {
    return client[apiModel].restore(id);
  };

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: [queryKey] });
    invalidateKeys?.forEach((queryKey) =>
      queryClient.invalidateQueries({ queryKey })
    );
  };

  return useMutation({
    mutationFn,
    onSuccess,
  });
};
